import { Box, Button, Typography } from '@mui/material';
import Image from 'components/Image/Image';
import { useAnalytics } from 'contexts/Analytics/Analytics';
import { useContent } from 'contexts/Content/Content';
import { parseHtml } from 'helpers';
import { useEffect, useState } from 'react';

const CTA_RESOURCE_ID = 'krobar_simulation_cta';
const CTA_SOURCE = 'simulation_cta';

export default function SimulationCta() {

    const [ready, setReady] = useState(false);
    const analytics = useAnalytics();
    const content = useContent();
    const { buttonLabel, buttonLink, image, text, title } = content.simulation.cta;

    useEffect(() => {
        if (!ready) {
            setReady(true);
            void analytics.trackEvent('krobar_ad_viewed', {
                destination_url: buttonLink,
                resource_id: CTA_RESOURCE_ID,
                resource_type: 'ad',
                source: CTA_SOURCE,
            });
        }
    }, [
        analytics,
        buttonLink,
        ready,
    ]);

    function handleButtonClick() {
        void analytics.trackEvent('krobar_ad_clicked', {
            destination_url: buttonLink,
            resource_id: CTA_RESOURCE_ID,
            resource_type: 'ad',
            source: CTA_SOURCE,
        });
    }

    return <Box display="flex">
        <Box alignItems="center" bgcolor="white" display="flex" flex={1} flexDirection="column" gap={3} justifyContent="center" padding={3}>
            <Image alt="Krobar logo" src="/assets/images/krobar-black.svg" style={{ maxWidth: 220, width: '100%' }} />
            <Image alt="Krobar forecast chart" src={image} style={{ maxWidth: '100%' }} />
        </Box>
        <Box bgcolor="secondary.light" flex={1}>
            <Box padding={3}>
                {title && (
                    <Typography dangerouslySetInnerHTML={parseHtml(title)} paragraph variant="roboto424" />
                )}
                {text && (
                    <Typography dangerouslySetInnerHTML={parseHtml(text)} paragraph variant="roboto414" />
                )}
                {buttonLink && buttonLabel && (
                    <Button
                        data-testid="simulation-cta-link"
                        href={buttonLink}
                        onClick={handleButtonClick}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        {buttonLabel}
                    </Button>
                )}
            </Box>
        </Box>
    </Box>;

}
